// 创建一个需要混入的对象
export const cartMixin = {
  data() {
    return {
      hello: 'hello,mixins',
    }
  },
  methods: {
    isDevEnv() {
      //判断是否开发环境
      const isDev = process.env.NODE_ENV === 'development'
      return isDev
    },
    isOnWeixin(){
      return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    },
    array_unique(arr) {
      //数组值去重功能
      const res = new Map();
      return arr.filter((a) => !res.has(a) && res.set(a, 1))
    },
    fmPrice(price_value) {
      //价格信息格式化
      return parseFloat(price_value).toFixed(2)
    },
    getUrlParams(new_params) {
      //获取路由url中的参数
      const tempParams = this.$route.query
      const h5api = (tempParams.h5api == undefined) ? {
        h5api: 'on'
      } : {
          h5api: tempParams.h5api
        }
      const finalParams = (new_params) ? Object.assign(tempParams, h5api, new_params) : Object.assign(tempParams, h5api)
      return finalParams
    },
    get_index_slide(apiData) {
      //首页轮播图
      const { waplist } = apiData
      const slideList = waplist.thumbs && waplist.thumbs.map(item => {
        return item.slide_src
      })
      return slideList
    },
    filterGoodsListIndex(goods_list) {
      //获取商品列表对象
      let goodsArr = {}
      goods_list && goods_list.forEach(catalog => {
        catalog && catalog.items.forEach(item => {
          goodsArr[item.sku] = {
            goods_id: item.id,
            price: item.marketprice,
            sku: item.sku,
            goods_name: item.title,
          }
        })
      })
      return goodsArr
    },
    getOptionName(currentAttr) {
      //获取规格名称
      const arr_optname = currentAttr && currentAttr.length && currentAttr.map(optItem => {
        const real_name = Object.entries(optItem).filter(nitem => {
          if (nitem[0] == 'optionid' || nitem[0] == 'price') {
            console.log(nitem[1]);
          } else {
            return nitem
          }
        })
        return real_name[0][1]
      })
      return currentAttr.length ? arr_optname.join(',') : ''
    },
    getOptionId(currentAttr) {
      //获取规格ID
      const arr_optid = currentAttr && currentAttr.length && currentAttr.map(optItem => {
        return optItem.optionid
      })
      return currentAttr.length ? arr_optid.join('_') : ''
    },
    /**
     * 获取购物车中被点击打开item的已被选中的规格
     * @param {item的属性列表} goods_attr_list 
     * @param {api返回的已选中的规格列表} choosed_id_list 
     */
    getCartChoosedOption(goods_attr_list, choosed_id_list) {
      let json_attr = {}, json_mulattr = []
      goods_attr_list && goods_attr_list.forEach(xitem_list => {
        let is_multiple = false
        if (xitem_list.items[0]['is_multiple'] == 1) {
          is_multiple = true
        }

        if (is_multiple == false) {
          json_attr[xitem_list.title] = ''
          let mulattr = {}

          xitem_list && xitem_list.items && xitem_list.items.length && xitem_list.items.forEach((xitem, xkey) => {
            const int_exist = choosed_id_list.findIndex((v) => {
              return v == xitem.id
            })
            if (int_exist >= 0) {
              mulattr[xitem.start] = xitem.title
              mulattr["optionid"] = xitem.optionid || xitem.id
              mulattr["price"] = xitem.price
              json_mulattr.push(mulattr)

              json_attr[xitem_list.title] = xitem.id
            }
          })
        }
        
        if (is_multiple == true) {
          json_attr[xitem_list.title] = []
          let mulattr = {}
          xitem_list && xitem_list.items && xitem_list.items.length && xitem_list.items.forEach((xitem, xkey) => {
            const int_exist = choosed_id_list.findIndex((v) => {
              return v == xitem.id
            })
            if (int_exist >= 0) {
              json_mulattr.push({
                [xitem.start]:xitem.title,
                "optionid":xitem.id,
                "price":xitem.price,
              })
              json_attr[xitem_list.title].push(xitem.id)
            }
          })
        }
      })
      return { attr: json_attr, mulattr: json_mulattr }
    }

  }
};